import React, { useCallback, useEffect, useState } from "react";
import { Check, Trash2, MessageCircle, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, whatsappLink } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "");

export function ContactAdmin({ onChange }) {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/admin/contact").then((r) => setData(r.data)).catch(console.error), []);
  useEffect(() => { load(); }, [load]);

  const markRead = async (id) => {
    try { await api.patch(`/admin/contact/${id}/read`); load(); onChange?.(); } catch { toast.error("Erreur"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    try { await api.delete(`/admin/contact/${id}`); load(); onChange?.(); } catch { toast.error("Erreur"); }
  };

  if (!data) return <p className="text-zinc-500">Chargement...</p>;
  return (
    <div data-testid="admin-contact">
      <h2 className="font-anton text-2xl uppercase text-white mb-1">Messages de contact <span className="text-neon-magenta">({data.total})</span></h2>
      <p className="text-zinc-500 text-sm mb-5">{data.unread} non lu{data.unread > 1 ? "s" : ""} · reçus via la page /contact</p>
      {data.messages.length === 0 && <p className="text-zinc-500" data-testid="admin-contact-empty">Aucun message pour le moment.</p>}
      <div className="space-y-3">
        {data.messages.map((m) => (
          <div key={m.id} data-testid="admin-contact-row" className={`border p-4 ${m.read ? "border-zinc-800 opacity-70" : "border-neon-magenta/60 bg-neon-magenta/5"}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div>
                <p className="text-white font-bold">{m.name} {!m.read && <span className="ml-2 text-[10px] uppercase bg-neon-magenta text-white px-1.5 py-0.5">Nouveau</span>}</p>
                <p className="text-zinc-500 text-xs">{fmt(m.created_at)} {m.email && `· ${m.email}`} {m.phone && `· ${m.phone}`}</p>
              </div>
              <div className="flex gap-2">
                {m.phone && <a data-testid="admin-contact-whatsapp" href={whatsappLink(m.phone, `Bonjour ${m.name}, STUFF France — suite à ton message :`)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs uppercase font-bold px-3 py-1.5 bg-neon-green text-black"><MessageCircle className="h-3.5 w-3.5" /> WhatsApp</a>}
                {m.email && <a href={`mailto:${m.email}?subject=STUFF%20France%20—%20ta%20demande`} className="inline-flex items-center gap-1 text-xs uppercase font-bold px-3 py-1.5 border border-zinc-700 text-zinc-300 hover:border-neon-green"><Mail className="h-3.5 w-3.5" /> Email</a>}
                {!m.read && <button data-testid="admin-contact-read" onClick={() => markRead(m.id)} className="inline-flex items-center gap-1 text-xs uppercase font-bold px-3 py-1.5 border border-zinc-700 text-zinc-300 hover:border-neon-green"><Check className="h-3.5 w-3.5" /> Lu</button>}
                <button data-testid="admin-contact-delete" onClick={() => remove(m.id)} className="inline-flex items-center text-xs px-2 py-1.5 border border-zinc-800 text-zinc-500 hover:text-red-400 hover:border-red-400"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </div>
            <p className="text-zinc-300 text-sm mt-3 whitespace-pre-wrap">{m.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
